// extracted by mini-css-extract-plugin
module.exports = {"Oembed":"_1P5orKhnvj0DdRlgDHQ28m"};